"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRubyApiClient = void 0;
const accounts_api_1 = require("../accounts/accounts-api");
const apple_auth_api_1 = require("../apple-auth/apple-auth-api");
const apple_channels_api_1 = require("../apple-channels/apple-channels-api");
const apple_proxy_api_1 = require("../apple-proxy/apple-proxy-api");
const apple_replica_api_1 = require("../apple-replica/apple-replica-api");
const attribution_api_1 = require("../attribution/attribution-api");
const budgets_api_1 = require("../budgets/budgets-api");
const errors_1 = require("../errors");
const exchange_rate_api_1 = require("../exchange-rates/exchange-rate-api");
const history_api_1 = require("../history/history-api");
const ingress_api_1 = require("../ingress/ingress-api");
const interactions_api_1 = require("../interactions/interactions-api");
const notifications_api_1 = require("../notifications/notifications-api");
const organic_replica_1 = require("../organic-replica");
const rules_1 = require("../rules");
const services_1 = require("../services");
function createRubyApiClient(networkClient) {
    const accounts = (0, accounts_api_1.accountApiClient)(networkClient);
    return {
        accounts,
        appleAuth: (0, apple_auth_api_1.appleAuthApiClient)(networkClient),
        appleChannels: (0, apple_channels_api_1.appleChannelApiClient)(networkClient),
        appleProxy: (0, apple_proxy_api_1.appleProxyApiClient)(networkClient),
        appleReplica: (0, apple_replica_api_1.appleReplicaApiClient)(networkClient),
        errors: (0, errors_1.errorApiClient)(networkClient),
        exchangeRates: (0, exchange_rate_api_1.exchangeRateApiClient)(networkClient),
        attributions: (0, attribution_api_1.attributionApiClient)(networkClient),
        budgets: (0, budgets_api_1.budgetApiClient)(networkClient),
        interactions: (0, interactions_api_1.interactionApiClient)(networkClient),
        notifications: (0, notifications_api_1.notificationApiClient)(networkClient),
        history: (0, history_api_1.historyApiClient)(networkClient),
        ingress: (0, ingress_api_1.ingressApiClient)(networkClient),
        rules: (0, rules_1.rulesApiClient)(networkClient),
        services: (0, services_1.servicesApiClient)(networkClient),
        organicReplica: (0, organic_replica_1.organicReplicaApiClient)(networkClient),
        context: async (request) => {
            return accounts.getContext(request ?? {});
        },
        log: networkClient.log,
    };
}
exports.createRubyApiClient = createRubyApiClient;
